/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Alert from "./Alert";
import L from "./Lang"
import BaseCom from "./BaseCom";
import DataTable from "./DataTable";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";

class Patients extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            query: {},
            loaded: false,
            loading: false,
            list: []
        };
        this.load = this.load.bind(this);
    }

    componentDidMount() {
        this.load();
    }

    load() {
        this.setState({ loading: true });
        qreq.post('/api/patient/list', this.state.query, j => {
            if (j.list) {
                this.setState({ list: j.list });
            }
            else if (j.errorCode !== 0) {
                this.setState({ errorMessage: j.errorMessage });
            }
            this.setState({ loaded: true, loading: false });
        }, () => {
            this.setState({ loaded: true, loading: false, errorMessage: 'Unknown error ocurred.' });
        });
    }

    render() {
        const header = (<h1><L>Patients</L></h1>);

        if (!this.state.loaded)
            return (<div className="container-fluid">{header}<LoadingAlert /></div>);

        if (this.state.errorMessage)
            return <Alert type="danger" icon="ExclamationTriangle" message={this.state.errorMessage} />

        return <div className="container-fluid">
            {header}
            <DataTable columns={[
                { icon: 'Eye', link: '/patient/view/:id', tooltip: 'View Patient' },
                { name: 'id', title: 'ID', link: '/patient/view/:id', tooltip: 'View Patient' },
                { name: 'name', title: 'Full Name', link: '/patient/view/:id', tooltip: 'View Patient' },
                { name: 'birthDate', title: 'Birth Date' },
                { name: 'createdDate', title: 'Created Date' },
                {
                    button: 'Add Record', icon: 'Plus', onClick: (row) => {
                        this.props.navigate('/patient/view/' + row.id);
                    }
                }
            ]} data={this.state.list} loading={this.state.loading} />
        </div>;
    }
}

export default withParamsAndNavigate(Patients);